import { module } from 'angular';

import { ContactHistoryService, default as contactHistoryServiceName } from './contact-history.service';

export default module('contact.agent.core.contact.contact-history', []).service(contactHistoryServiceName, ContactHistoryService).name;
